import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

export const PermitDetailSkeleton: React.FC = () => {
  return (
    <Box>
      {/* Back button skeleton */}
      <Skeleton variant="rectangular" width={140} height={36} sx={{ mb: { xs: 2, md: 3 }, borderRadius: 1 }} />

      {/* Header skeleton */}
      <Box sx={{ mb: 3 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "flex-start" },
            gap: 2,
            mb: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
              <Skeleton variant="text" width={250} height={40} />
              <Skeleton variant="rounded" width={80} height={24} />
            </Box>
            <Skeleton variant="text" width={150} height={24} />
          </Box>
          <Skeleton variant="rectangular" width={160} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      <Grid container spacing={3}>
        {/* Main content */}
        <Grid item xs={12} lg={8}>
          {/* Alert skeleton */}
          <Skeleton variant="rectangular" height={80} sx={{ mb: 3, borderRadius: 1 }} />

          {/* Details section skeleton */}
          <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 3 }} />
            <Grid container spacing={3}>
              {[1, 2, 3, 4, 5].map((i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={120} height={28} sx={{ mt: 0.5 }} />
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Vehicles section skeleton */}
          <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
            <Skeleton variant="text" width={150} height={32} sx={{ mb: 2 }} />
            {[1, 2, 3].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={56}
                sx={{ mb: 1, borderRadius: 1, "&:last-child": { mb: 0 } }}
              />
            ))}
          </Paper>

          {/* Documents section skeleton */}
          <Paper sx={{ p: { xs: 2, md: 3 }, mb: 3 }}>
            <Skeleton variant="text" width={180} height={32} sx={{ mb: 2 }} />
            {[1, 2].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={72}
                sx={{ mb: 1, borderRadius: 1, "&:last-child": { mb: 0 } }}
              />
            ))}
          </Paper>
        </Grid>

        {/* Sidebar skeleton */}
        <Grid item xs={12} lg={4}>
          <Paper sx={{ p: 3 }}>
            <Skeleton variant="text" width={100} height={28} sx={{ mb: 2 }} />
            {[1, 2, 3].map((i) => (
              <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 2, mb: 2 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width={80} height={20} />
                  <Skeleton variant="text" width={100} height={24} />
                </Box>
              </Box>
            ))}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PermitDetailSkeleton;
